import { getCurrentSessionToken, refreshSessionWithBackend } from "./cognito";

function isTokenExpired(token: string): boolean {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return true;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    const decoded = JSON.parse(jsonPayload);
    const exp = decoded.exp;
    if (!exp) return true;
    // Buffer of 5 minutes (300 seconds)
    return (Date.now() / 1000) + 300 > exp;
  } catch (e) {
    return true;
  }
}

/**
 * Returns the common HTTP headers required by all protected backend endpoints.
 * Retrieves the active Cognito JWT and builds the Authorization header.
 * If the token is expired or close to expiring, it attempts to refresh it
 * via the backend refresh service.
 *
 * @throws {Error} If the user is not authenticated or the session has expired.
 */
export async function getAuthHeaders(): Promise<{ Authorization: string }> {
  let token = await getCurrentSessionToken();

  if (!token) {
    throw new Error("No active session — user must be authenticated.");
  }

  if (isTokenExpired(token)) {
    console.log("Access token is expired or expiring soon. Attempting backend refresh...");
    const refreshedToken = await refreshSessionWithBackend();
    if (refreshedToken) {
      token = refreshedToken;
    }
  }

  return { Authorization: `Bearer ${token}` };
}

